import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const ReportsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Raporlar" />
      <div className="card">
        <div className="card-body">
          <h5>Raporlar</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default ReportsPage;

